import { action, computed, makeObservable, observable } from 'mobx';
import {
    ALL_PROVINCES,
    ApplicationSelection,
    ApplicationTargetEnum,
    CIRCLE_K_PROVINCES,
    COUCHE_TARD_PROVINCES,
    SELECTED_APPLICATION_STORAGE_KEY,
} from '../types/app-selection';
import { RootStore } from './root';

export class ApplicationSelectionStore {
    rootStore: RootStore;
    @observable selectedApplication: ApplicationSelection =
        ApplicationSelection.ALL_REGIONS;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeObservable(this);
        this.initializeFromStorage();
    }

    private initializeFromStorage() {
        const stored = localStorage.getItem(SELECTED_APPLICATION_STORAGE_KEY);
        if (
            stored &&
            Object.values(ApplicationSelection).includes(
                stored as ApplicationSelection
            )
        ) {
            this.selectedApplication = stored as ApplicationSelection;
        } else {
            this.selectedApplication = ApplicationSelection.ALL_REGIONS;
            localStorage.setItem(
                SELECTED_APPLICATION_STORAGE_KEY,
                ApplicationSelection.ALL_REGIONS
            );
        }
    }

    @action
    setSelectedApplication(application: ApplicationSelection) {
        this.selectedApplication = application;
        localStorage.setItem(SELECTED_APPLICATION_STORAGE_KEY, application);
    }

    @computed
    get getProvincesFromSelectedApplication() {
        if (this.selectedApplication === ApplicationSelection.ALL_REGIONS) {
            return ALL_PROVINCES.join(',');
        }
        if (this.selectedApplication === ApplicationSelection.CIRCLE_K) {
            return CIRCLE_K_PROVINCES.join(',');
        }
        if (this.selectedApplication === ApplicationSelection.COUCHE_TARD) {
            return COUCHE_TARD_PROVINCES.join(',');
        }
    }

    @computed
    get appTarget() {
        if (this.selectedApplication === ApplicationSelection.COUCHE_TARD) {
            return ApplicationTargetEnum.QC;
        }
        if (this.selectedApplication === ApplicationSelection.CIRCLE_K) {
            return ApplicationTargetEnum.CA;
        }
        return undefined;
    }
}
